import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAncPregBackHandler } from '@store/actions/beneficiaryAction';
import { benfTabs } from '@constants/appConstants';

const useNavigateWithMenuItem = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

    /**
   * Navigates to a specified route with an optional menu item and state.
   * @param {string} route - The route to navigate to.
   * @param {string} [menuItem=benfTabs.overview] - The menu item to set in the Redux store.
   * @param {any} [state] - Optional state to pass along with the navigation.
   */
  const navigateWithMenuItem = (route: string, menuItem: string = benfTabs.overview, state?: any) => {
    const backObj = {
      menuItems: menuItem,
    };

    dispatch(setAncPregBackHandler(backObj));
    navigate(route, { state });
  };

  return navigateWithMenuItem;
};

export default useNavigateWithMenuItem;